import React, { useMemo } from 'react';

import { VerificationLevels } from 'common/hooks/useCustomer/useCustomer.constants';
import { useCustomer } from 'common/hooks/useCustomer/useCustomer.hook';
import svgIcons from 'common/svgIcons';

import SvgIconUrl from '../SvgIconUrl/SvgIconUrl.component';

export const UserAvatar: React.FC<React.PropsWithChildren> = () => {
  const {
    intermediateVerificationLevelStatus: { verificationLevel },
  } = useCustomer();

  const progress = useMemo(() => {
    switch (verificationLevel) {
      case VerificationLevels.BASIC:
        return 330;
      case VerificationLevels.OCCASIONAL:
        return 300;
      case VerificationLevels.PRO:
        return 360;

      default:
        return 270;
    }
  }, [verificationLevel]);

  return (
    <div className='user__avatar'>
      <SvgIconUrl symbol={svgIcons.AvatarUniversal()} className='user__avatar-icon' />
      <div className='user__progress-bar'>
        <svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
          <defs>
            <linearGradient id='gradient' x1='0%' y1='0%' x2='0%' y2='100%'>
              <stop offset='0%' stopColor='var(--main_color)' />
              <stop offset='100%' stopColor='var(--green)' />
            </linearGradient>
          </defs>
          <circle
            cx='50'
            cy='50'
            r='46'
            stroke='var(--light-grey)'
            strokeWidth='6'
            fill='none'
            transform='rotate(90 50 50)'
            strokeLinecap='round'
          />
          <circle
            cx='50'
            cy='50'
            r='46'
            stroke={progress === 360 ? 'var(--green)' : 'url(#gradient)'}
            strokeWidth='6'
            strokeDashoffset='790'
            strokeDasharray={progress}
            transform='rotate(270 50 50)'
            fill='none'
            strokeLinecap='round'
          />
        </svg>
      </div>
    </div>
  );
};
